<template>
  <el-dialog v-dialogDrag :visible="visible" :close-on-click-modal="false" top="20vh" v-bind="$attrs" :width="width" :fullscreen="fullscreen" v-on="$listeners" @close="close">
    <button type="button" class="el-dialog__fullscreenBtn"><i v-if="fullscreenIcon" class="el-icon-full-screen" @click="fullscreenResize" /></button>
    <slot />
    <slot v-if="footer" name="footer">
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="close">取 消</el-button>
        <el-button type="primary" size="medium" :loading="loading" @click="submit">确 定</el-button>
      </span>
    </slot>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '720px'
    },
    footer: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    fullscreenIcon: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {
    // isFooter() {
    //   const footer = this.$attrs?.footer
    //   const isFooter = Object.prototype.hasOwnProperty.call(this.$attrs, 'footer')
    //   if (isFooter && footer !== false) return true
    //   else return false
    // }
  },
  watch: {},
  methods: {
    handleClose() {},
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      // eslint-disable-next-line no-unused-expressions
      Object.prototype.hasOwnProperty.call(this.$attrs, 'initdata') ? this.$parent.hide() : ''
    },
    submit() {
      this.$emit('ok')
    },
    fullscreenResize() {
      this.$emit('update:fullscreen', !this.fullscreen)
      this.$emit('fullscreenResize')
    }
  }
}
</script>
<style lang="less" scoped>
.el-dialog__fullscreenBtn {
  position: absolute;
  top: 20px;
  right: 50px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}
.el-icon-full-screen {
  color: #909399;
}
/deep/ .is-fullscreen {
  top: 0 !important;
  left: 0 !important;
}
/deep/ .el-dialog {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}
/deep/ .el-dialog__header {
  font-size: 17px;
  font-weight: 500;
}
/deep/ .el-dialog__body {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 15px 20px;
  border-top: 1px solid #e7e7e7;
  // border-bottom: 1px solid #e7e7e7;
}
/deep/ .el-dialog__footer {
  border-top: 1px solid #e7e7e7;
  padding: 10px 20px;
}
</style>
